/*
 * @Author: zhouwei
 * @Date: 2019-11-25 15:22:09
 * @Last Modified by: zhouwei
 * @Last Modified time: 2019-12-05 14:49:21
 * @Desc: 充值说明模块
*/
<template>
  <mk-drawer
    :visible.sync="show"
    class="explain"
    size="500px"
    hide-header
    :before-close="cancel"
  >
    <div class="header">
      <h3>充值说明</h3>
      <mk-iconfont
        class="icon"
        icon-class="guanbi"
        @click.native="cancel"
      ></mk-iconfont>
    </div>
    <div class="content">
      <ul>
        <li
          v-for="(item,index) in list"
          :key="index"
        >
          {{ item }}
        </li>
      </ul>
    </div>
  </mk-drawer>
</template>
<script>
export default {
  props: {
    show: {
      type: Boolean,
      defalut: false
    }
  },
  data () {
    return {
      list: [
        '1、推广投放采用预充值的形式，请联系销售人员协商充值方式',
        '2、线下充值完成后，工作人员会将相应金额添加到您的账户余额',
        '3、推广进行过程中，余额实时扣除，当余额为0时自动停止推广任务'
      ]
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.explain {
  .header {
    height: 60px;
    box-sizing: border-box;
    padding: 0 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: 0 1px 0 0 #e8e8e8;

    h3 {
      font-size: 16px;
      line-height: 22px;
      color: #262626;
    }

    .icon {
      color: #bfbfbf;
      cursor: pointer;
    }
  }

  .content {
    width: calc(100% - 50px);
    margin: 0 auto;
    height: calc(100% - 110px);
    margin-top: 25px;
    color: #262626;
    display: flex;

    ul {
      line-height: 24px;

      li {
        margin-top: 8px;
      }
    }
  }
}
</style>
